/* eslint-disable no-unused-vars */
import React from "react";
import { useSelector } from "react-redux";

const Form2Print = React.forwardRef(({ form2PrintRef }, ref) => {
  const { printData } = useSelector((state) => state.cvd);

  const currentDate = new Date();

  const options = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    timeZone: "Asia/Kolkata",
  };
  const formattedDate = currentDate.toLocaleDateString("en-IN", options);
  let hours = currentDate.getHours();
  let minutes = currentDate.getMinutes();
  const amOrPm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours || 12;
  hours = hours.toString().padStart(2, "0");
  minutes = minutes.toString().padStart(2, "0");
  // eslint-disable-next-line no-unused-vars
  // const formattedTime = `${hours}:${minutes} ${amOrPm}`;
  return (
    <div ref={form2PrintRef}>
      <table
        border={0}
        cellSpacing={0}
        role="presentation"
        cellPadding={0}
        style={{
          backgroundColor: "#ffffff",
          maxWidth: "364px",
          width: "100%",
          borderCollapse: "collapse",
          margin: "0 auto",
          // border: "1px solid #000000",
          fontSize: 8,
        }}
      >
        <tbody>
          <tr>
            <td>
              <table>
                <tbody>
                  <tr>
                    <td style={{ width: 48, paddingRight: 34 }}>
                      <img
                        src={printData?.branch?.logo}
                        alt="logo"
                        width={48}
                        height={48}
                        style={{
                          width: 48,
                          height: 48,
                          minWidth: 48,
                          maxWidth: 48,
                        }}
                      />
                    </td>
                    <td>
                      <table
                        align="center"
                        border={0}
                        cellSpacing={0}
                        role="presentation"
                        cellPadding={0}
                        width="100%"
                        style={{
                          borderCollapse: "collapse",
                          backgroundColor: "#ffffff",
                          boxSizing: "border-box",
                        }}
                      >
                        <tbody>
                          <tr>
                            <td
                              style={{
                                fontSize: 15,
                                fontWeight: 800,
                                textAlign: "center",
                                lineHeight: "28px",
                              }}
                            >
                              {printData?.branch?.name}
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{
                                fontSize: 8,
                                fontWeight: 600,
                                textAlign: "center",
                              }}
                            >
                              {printData?.branch?.address?.address_line1}
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{
                                fontSize: 8,
                                fontWeight: 600,
                                textAlign: "center",
                                paddingBottom: 10,
                              }}
                            >
                              {printData?.branch?.country_code}-
                              {printData?.branch?.contact_number_1},
                              {printData?.branch?.contact_number_2 && (
                                <>
                                  {printData?.branch?.country_code}-
                                  {printData?.branch?.contact_number_2}
                                </>
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>

          <tr>
            <td style={{ padding: "0px 115px 8px" }}>
              <table
                align="center"
                border={0}
                cellSpacing={0}
                role="presentation"
                cellPadding={0}
                width="100%"
                style={{
                  borderCollapse: "collapse",
                  backgroundColor: "#000000",
                  boxSizing: "border-box",
                  color: "#ffffff",
                }}
              >
                <tbody>
                  <tr>
                    <td
                      style={{
                        textAlign: "center",
                        fontSize: 8,
                        textTransform: "uppercase",
                        fontWeight: 600,
                        padding: "2px 0",
                      }}
                    >
                      CVD REPORT - {printData?.item_type?.toUpperCase()}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>

          <tr>
            <td>
              <table
                border={0}
                cellSpacing={0}
                role="presentation"
                cellPadding={0}
                style={{
                  width: "100%",
                }}
              >
                <tbody>
                  <tr>
                    <td
                      style={{
                        paddingBottom: 4,
                      }}
                    >
                      <table
                        border={0}
                        cellSpacing={0}
                        role="presentation"
                        cellPadding={0}
                      >
                        <tbody>
                          <tr>
                            <td>GLI.No</td>
                            <td
                              style={{
                                width: 6,
                                padding: "0px 2px",
                                fontWeight: 500,
                              }}
                            >
                              :
                            </td>
                            <td
                              style={{
                                fontWeight: 600,
                              }}
                            >
                              {printData?.gli_number}
                            </td>
                          </tr>
                          {/* <tr>
                            <td>Time</td>
                            <td
                              style={{
                                width: 6,
                                padding: "2px 2px",
                                fontWeight: 500,
                              }}
                            >
                              :
                            </td>
                            <td
                              style={{
                                fontWeight: 600,
                              }}
                            >
                              {formattedTime}
                            </td>
                          </tr> */}
                        </tbody>
                      </table>
                    </td>
                    <td
                      style={{
                        paddingBottom: 4,
                      }}
                    >
                      <table
                        border={0}
                        cellSpacing={0}
                        role="presentation"
                        cellPadding={0}
                        style={{
                          marginLeft: "auto",
                          marginRight: 0,
                        }}
                      >
                        <tbody>
                          <tr>
                            <td>Date</td>
                            <td
                              style={{
                                width: 6,
                                padding: "2px 2px",
                                fontWeight: 500,
                              }}
                            >
                              :
                            </td>
                            <td
                              style={{
                                fontWeight: 600,
                              }}
                            >
                              {printData?.date}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>

                  <tr>
                    <td
                      colSpan={2}
                      style={{
                        verticalAlign: "top",
                        padding: "6px 0px",
                      }}
                    >
                      <table
                        border={0}
                        cellSpacing={0}
                        role="presentation"
                        cellPadding={0}
                      >
                        <tbody>
                          <tr>
                            <td
                              style={{
                                width: 72,
                                verticalAlign: "top",
                              }}
                            >
                              Supplier
                            </td>
                            <td
                              style={{
                                width: 10,
                                padding: "0px 4px",
                                fontWeight: 500,
                                verticalAlign: "top",
                              }}
                            >
                              :
                            </td>
                            <td
                              style={{
                                fontWeight: 600,
                              }}
                            >
                              {printData?.supplier?.name}
                              <br />
                              {printData?.supplier?.address?.address_line1},
                              {printData?.supplier?.address?.address_line2}
                              <br />
                              {printData?.supplier?.address?.city},
                              {printData?.supplier?.address?.state}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>

                  <tr>
                    <td
                      colSpan={2}
                      style={{
                        verticalAlign: "top",
                        padding: "6px 0px",
                      }}
                    >
                      <table
                        border={0}
                        cellSpacing={0}
                        role="presentation"
                        cellPadding={0}
                      >
                        <tbody>
                          <tr>
                            <td
                              style={{
                                width: 72,
                                verticalAlign: "top",
                              }}
                            >
                              For the Shop
                            </td>
                            <td
                              style={{
                                width: 10,
                                padding: "0px 4px",
                                fontWeight: 500,
                                verticalAlign: "top",
                              }}
                            >
                              :
                            </td>
                            <td
                              style={{
                                fontWeight: 600,
                                verticalAlign: "top",
                              }}
                            >
                              <span
                                style={{
                                  maxWidth: 200,
                                  display: "inline-block",
                                }}
                              >
                                {printData?.shop?.name} <br />
                                {printData?.shop?.address?.address_line1},
                                {printData?.shop?.address?.address_line2}
                                <br />
                                {printData?.shop?.address?.city},
                                {printData?.shop?.address?.state}
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>

          <tr>
            <td
              style={{
                padding: "9px 0 15px",
              }}
            >
              <table
                border={0}
                cellSpacing={0}
                role="presentation"
                cellPadding={0}
                style={{
                  width: "100%",
                  borderTop: "0.5px solid #C8C8C8",
                }}
              >
                <tbody>
                  {printData?.data?.map((value, i) => (
                    <tr key={i}>
                      <td>
                        <table
                          border={0}
                          cellSpacing={0}
                          role="presentation"
                          cellPadding={0}
                          style={{
                            width: "100%",
                            border: "0.5px solid #C8C8C8",
                            borderTop: 0,
                          }}
                        >
                          <tbody>
                            <tr>
                              <td
                                style={{
                                  width: 70,
                                  backgroundColor: "#FAFAFA",
                                  borderRight: "0.5px solid #C8C8C8",
                                  borderBottom: "0.5px solid #C8C8C8",
                                  textAlign: "center",
                                  textWrap: "balance",
                                  fontWeight: 500,
                                  padding: "3.5px 5px",
                                }}
                              >
                                {value?.item}
                              </td>
                              <td>
                                <table
                                  border={0}
                                  cellSpacing={0}
                                  role="presentation"
                                  cellPadding={0}
                                  style={{
                                    width: "100%",
                                  }}
                                >
                                  <tbody>
                                    <tr>
                                      <td style={{ padding: 0 }}>
                                        <table
                                          cellSpacing={0}
                                          role="presentation"
                                          cellPadding={0}
                                          style={{
                                            width: "100%",
                                          }}
                                        >
                                          {i === 0 && (
                                            <thead>
                                              <tr>
                                                <th
                                                  style={{
                                                    padding: "3.5px 5px",
                                                    fontWeight: 700,
                                                    fontSize: 7,
                                                    backgroundColor: "#FDFEFF",
                                                    borderBottom:
                                                      "0.5px solid #C8C8C8",
                                                    borderRight:
                                                      "0.5px solid #C8C8C8",
                                                    textAlign: "left",
                                                    width: 127,
                                                  }}
                                                >
                                                  Particulars
                                                </th>
                                                <th
                                                  style={{
                                                    padding: "3.5px 5px",
                                                    fontWeight: 700,
                                                    fontSize: 7,
                                                    backgroundColor: "#FDFEFF",
                                                    borderBottom:
                                                      "0.5px solid #C8C8C8",
                                                    borderRight:
                                                      "0.5px solid #C8C8C8",
                                                    textAlign: "center",
                                                    width: 55.67,
                                                  }}
                                                >
                                                  Weight
                                                </th>
                                                <th
                                                  style={{
                                                    padding: "3.5px 5px",
                                                    fontWeight: 700,
                                                    fontSize: 7,
                                                    backgroundColor: "#FDFEFF",
                                                    borderBottom:
                                                      "0.5px solid #C8C8C8",
                                                    borderRight:
                                                      "0.5px solid #C8C8C8",
                                                    textAlign: "center",
                                                    width: 55.67,
                                                  }}
                                                >
                                                  D/No
                                                </th>
                                                <th
                                                  style={{
                                                    padding: "3.5px 5px",
                                                    fontWeight: 700,
                                                    fontSize: 7,
                                                    backgroundColor: "#FDFEFF",
                                                    borderBottom:
                                                      "0.5px solid #C8C8C8",
                                                    textAlign: "center",
                                                    width: 55.67,
                                                  }}
                                                >
                                                  %
                                                </th>
                                              </tr>
                                            </thead>
                                          )}
                                          <tbody>
                                            {/* table data mapping  */}
                                            {value?.particulars?.map(
                                              (val, i) => (
                                                <tr key={i}>
                                                  <td
                                                    style={{
                                                      padding: "5.5px 5px",
                                                      borderRight:
                                                        "0.5px solid #C8C8C8",
                                                      fontSize: 7,
                                                      fontWeight: 400,
                                                      textAlign: "left",
                                                      width: 127,
                                                    }}
                                                  >
                                                    {val?.name}
                                                  </td>
                                                  <td
                                                    style={{
                                                      padding: "5.5px 5px",
                                                      borderRight:
                                                        "0.5px solid #C8C8C8",
                                                      fontSize: 7,
                                                      fontWeight: 400,
                                                      textAlign: "center",
                                                      width: 55.67,
                                                    }}
                                                  >
                                                    {val?.weight}
                                                  </td>
                                                  <td
                                                    style={{
                                                      padding: "5.5px 5px",
                                                      borderRight:
                                                        "0.5px solid #C8C8C8",
                                                      fontSize: 7,
                                                      fontWeight: 400,
                                                      textAlign: "center",
                                                      width: 55.67,
                                                    }}
                                                  >
                                                    {val?.diamond_number}
                                                  </td>
                                                  <td
                                                    style={{
                                                      padding: "5.5px 5px",
                                                      fontSize: 7,
                                                      fontWeight: 400,
                                                      textAlign: "center",
                                                      width: 55.67,
                                                    }}
                                                  >
                                                    {val?.percentage}
                                                  </td>
                                                </tr>
                                              )
                                            )}
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>

                            {/* total  */}
                            <tr>
                              <td
                                style={{
                                  width: 70.5,
                                }}
                              ></td>
                              <td>
                                <table
                                  cellSpacing={0}
                                  role="presentation"
                                  cellPadding={0}
                                  style={{
                                    width: "100%",
                                  }}
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        style={{
                                          padding: "3.5px 5px",
                                          fontWeight: 700,
                                          fontSize: 8,
                                          backgroundColor: "#FDFEFF",
                                          borderTop: "0.5px solid #C8C8C8",
                                          borderRight: "0.5px solid #C8C8C8",
                                          textAlign: "left",
                                          width: 127,
                                        }}
                                      >
                                        Total
                                      </td>
                                      <td
                                        style={{
                                          padding: "3.5px 5px",
                                          fontWeight: 700,
                                          fontSize: 7,
                                          backgroundColor: "#FDFEFF",
                                          borderTop: "0.5px solid #C8C8C8",
                                          borderRight: "0.5px solid #C8C8C8",
                                          textAlign: "center",
                                          width: 55.67,
                                        }}
                                      >
                                        {value?.total?.weight}
                                      </td>
                                      <td
                                        style={{
                                          padding: "3.5px 5px",
                                          fontWeight: 700,
                                          fontSize: 7,
                                          backgroundColor: "#FDFEFF",
                                          borderTop: "0.5px solid #C8C8C8",
                                          borderRight: "0.5px solid #C8C8C8",
                                          textAlign: "center",
                                          width: 55.67,
                                        }}
                                      >
                                        {value?.total?.diamond_number}
                                      </td>
                                      <td
                                        style={{
                                          padding: "3.5px 5px",
                                          fontWeight: 700,
                                          fontSize: 7,
                                          backgroundColor: "#FDFEFF",
                                          borderTop: "0.5px solid #C8C8C8",
                                          textAlign: "center",
                                          width: 55.67,
                                        }}
                                      >
                                        {value?.total?.percentage}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
});

export default Form2Print;
